import { useEffect, useState, useMemo } from "react";
import { fetchAdminGroupReport } from "../../service/AdminService/groupService.js";
import usePagination from "../usePagination.js";
import { debounce } from "../../assets/utils/reportUtils.js";

const useGroupKpiReport = ({ groupStatus, searchText }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState(searchText);

  const {
    currentPage,
    pageSize,
    total,
    setTotal,
    paginationConfig,
    handlePageChange,
  } = usePagination();


  const debouncedSetSearch = useMemo(
    () =>
      debounce((value) => {
        setDebouncedSearch(value);
      }, 500),
    []
  );

  useEffect(() => {
    debouncedSetSearch(searchText);
  }, [searchText, debouncedSetSearch]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetchAdminGroupReport({
        page: currentPage,
        size: pageSize,
        isGroupActive: groupStatus === "active",
        search: debouncedSearch,
      });

      if (res?.success) {
        const { content = [], totalElements = 0 } = res.data || {};
        setData(content);
        setTotal(totalElements);
      } else {
        setData([]);
        setTotal(0);
      }
    } catch (err) {
      setData([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize, groupStatus, debouncedSearch]);

  return {
    data,
    loading,
    total,
    paginationConfig,
    handlePageChange,
  };
};

export default useGroupKpiReport;